import { FormValues, IFilter, StringOptions, NumberOptions, BooleanOptions } from "../../types";
import {
  formatDate,
  formatDateFilter,
} from "../../../../../utils/generalFormat";
import { Button, Col, Container, Label } from "../../styles";
import { Row } from "antd";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Select from "antd/lib/select";

export const FormFilter: React.FC<IFilter> = (props: IFilter) => {
  const { getFilters, userType } = props;
  const [finalReceiverTypeValue, setFinalReceiverTypeFieldValue] = useState("");

  const getInitialValues = (): FormValues => {
    const date = new Date();
    date.setHours(0, 0, 0, 1);
    const startDate = formatDate(date);
    date.setHours(23, 59, 59, 59);
    const finishDate = formatDate(date);
    return {
      rangeStartReceiveDate: startDate,
      rangeEndReceiveDate: finishDate,
      finalReceiverUserType: "",
      isAdmin: userType === 3 ? true : false,
    };
  };

  const handleChangeInitialDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    const date = new Date(value);
    setFieldValue("rangeStartReceiveDate", date);
  };

  const handleChangeEndDate = (
    event: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void
  ) => {
    const { value } = event.target;
    const date = new Date(value + "T23:59:59Z");
    setFieldValue("rangeEndReceiveDate", date);
  };

  const getFailedSettlements = async (submit: any) => {
    if (submit.startDate === "") {
      const date = new Date();
      date.setHours(0, 0, 0, 0);
      submit.startDate = formatDateFilter(date);
    } else {
      const formattedDateStart = formatDateFilter(submit.startDate);
      submit.startDate = formattedDateStart;
    }

    if (submit.finishDate === "") {
      const tomorrow = new Date();
      tomorrow.setHours(23, 59, 59, 0);
      submit.finishDate = formatDateFilter(tomorrow);
    } else {
      const formattedDateFinish = formatDateFilter(submit.finishDate);
      submit.finishDate = formattedDateFinish;
    }

    getFilters(submit);
    return submit;
  };

  const finalReceiverTypeOptions: StringOptions[] = [
    { label: "Tipo do Recebedor", value: "" },
    { label: "Pessoa Física", value: "F" },
    { label: "Pessoa Jurídica", value: "J" },
    { label: "Credor", value: "C" },
  ];

  useEffect(() => {
    getFailedSettlements(getInitialValues());
  }, []);

  return (
    <Container style={{ padding: "0px" }}>
      <Row>
        <Label>Filtrar por:</Label>
      </Row>

      <Formik
        initialValues={getInitialValues()}
        onSubmit={async (values: any) => {
          await getFailedSettlements(values);
        }}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <Row gutter={16}>
              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeInitialDate(e, setFieldValue)}
                  name="rangeStartReceiveDate"
                  placeholder="Data Inicial"
                  step="1"
                />
              </Col>

              <Col>
                <input
                  type="date"
                  onChange={(e) => handleChangeEndDate(e, setFieldValue)}
                  name="rangeEndReceiveDate"
                  placeholder="Data Final"
                  step="1"
                />
              </Col>

              <Col>
                <Select
                  defaultValue={finalReceiverTypeValue}
                  style={{width:'100%'}}
                  onChange={(value) => {
                    setFieldValue("finalReceiverUserType", value);
                    setFinalReceiverTypeFieldValue(value);
                    }}
                  options={finalReceiverTypeOptions}
                />
              </Col>

              <Col>
                <Button htmlType="submit">Consultar</Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </Container>
  );
};
